export enum UserFormErrorsEnum {
  BadUserName = "BadUserName",
  BadIsraeliId = "BadIsraeliId",
  BadPhoneNumber = "BadPhoneNumber",
  BadEmail = "BadEmail",
  BadOrganPrevaliges = "BadOrganPrevaliges",
  BadSystemStatus = "BadSystemStatus",
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-models/user-form-errors.enum.ts